<template>
  <div>
    <div class="bj">
      <img src="../../img/home/bj.png" alt="" style="width: 100vw" />
      <div style="position: absolute; top: 0vw">
        <!-- <div class="bt">液化气配送平台</div> -->
        <div id="banner" class="banner">
          <!-- <img src="../../img/home/yhq.png" alt="" style="width: 90vw" /> -->
          <!--轮播图-->
          <van-swipe :autoplay="3000">
            <van-swipe-item
              v-for="(item, index) in images"
              :key="index"
              @click="gotoBannerPage(item)"
            >
              <img v-lazy="imgUrl + item.dz" />
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="ggbj">
          <img
            src="../../img/home/ggbj.png"
            alt=""
            style="width: 90vw; height: 16vw"
          />
          <div
            style="
              position: absolute;
              top: 2vw;
              left: 9vw;
              width: 85vw;
              text-align: left;
              float: left;
              overflow: hidden;
            "
          >
            <div style="float: left">
              <img src="../../img/home/zxgg.png" alt="" style="width: 10vw" />
              <img
                src="../../img/home/line2.png"
                alt=""
                style="height: 11vw; margin-left: 3vw"
              />
            </div>
            <div
              @click="gotoTzggPage($event)"
              style="height: 12vw; overflow: hidden"
            >
              <vue-seamless-scroll :data="tzggs" :class-option="defaultOption">
                <ul class="ul-scoll">
                  <li v-for="(item, index) in tzggs" :key="index">
                    <div
                      class="singe-line"
                      style="margin-left: 4vw; padding: 0.8vw 0vw"
                      :data-obj="JSON.stringify(item.pid)"
                    >
                      {{ item.jtzy }}
                    </div>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100vw; margin-top: -7vw">
      <div style="margin-left: 2vw; height: 15vw">
        <img
          src="../../img/home/line1.png"
          alt=""
          style="width: 10vw; width: 1.5vw"
        />
        <span class="bt1" style="">便民专区</span>
      </div>
      <div style="text-align: center; position: relative" @click="goxd()">
        <img src="../../img/home/xdfw.png" alt="" style="width: 90vw" />
        <div class="bt2">
          <div class="bt3">下单服务</div>
          <div class="bt4">快速下单配送服务</div>
        </div>
      </div>
      <div
        style="text-align: center; top: 3vw; position: relative"
        @click="goscan()"
      >
        <img src="../../img/home/smcx.png" alt="" style="width: 90vw" />
        <div class="bt2">
          <div class="bt3">扫码查询</div>
          <div class="bt4">扫码快速查询信息</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../../../config/config.js";
import {
  getBannerList,
  getTzggList,
  checkopenid,
} from "../../api/ZghApi/ZghAx";
export default {
  data() {
    return {
      images: [],
      tzggs: [],
      imgUrl: config.fileShowUrl,
    };
  },
  components: {},
  created() {
    this.getBannerList();
    this.getTzggList();
  },
  destroyed() {},
  computed: {
    defaultOption() {
      return {
        step: 0.1, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量
        hoverStop: false, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  mounted() {},
  methods: {
    goscan() {
      this.$router.push({ name: "ypscan" });
    },
    goxd() {
      checkopenid({ openid: localStorage.getItem("openid") }).then((res) => {
        if (res.state == "ok") {
          if (
            res.info.c_tel1 != "" &&
            res.info.c_tel1 != undefined &&
            res.info.c_tel1 != null
          ) {
            localStorage.setItem("tel", res.info.c_tel1);
            this.$router.push({ name: "xd" });
          } else {
            this.$toast("信息获取失败,请联系管理员！");
          }
        } else if (res.state == "notfind") {
          this.$router.push({ name: "login" });
        } else if (res.state == "err") {
          this.$toast("信息获取失败,请联系管理员！");
        }
      });
    },
    getBannerList() {
      getBannerList({}).then((res) => {
        this.images = res.list;
      });
    },
    getTzggList() {
      getTzggList({}).then((res) => {
        this.tzggs = res.list;
      });
    },
    gotoBannerPage(item) {
      if (item.lx == "2") {
        return;
      } else if (item.lx == "0") {
        this.$router.push({
          name: "bannerdetail",
          params: {
            pid: item.pid,
          },
        });
      } else if (item.lx == "1") {
        window.open(item.ljdz);
      }
    },
    gotoTzggPage($event) {
      this.$router.push({
        name: "tzggdetail",
        params: {
          pid: JSON.parse($event.target.dataset.obj),
        },
      });
    },
  },
};
</script>
<style scoped >
.bj {
  /* background: url(../../img/home/bj.png) no-repeat center 0px; */
  width: 100vw;
  /* overflow: hidden; */
  text-align: center;
  position: relative;
  overflow: hidden;
}
.bt {
  font-size: 5.5vw;
  font-weight: 600;
  line-height: 26vw;
  height: 22vw;
  width: 100vw;
}
.bt1 {
  font-size: 5.5vw;
  font-weight: 500;
  line-height: 15vw;
  position: relative;
  top: -1.5vw;
}
.bt2 {
  text-align: left;
  position: absolute;
  top: 7vw;
  left: 10vw;
  width: 50vw;
}
.bt3 {
  font-size: 5vw;
  font-weight: 600;
}
.bt4 {
  font-size: 3.8vw;
  font-weight: 300;
  margin-top: 2.5vw;
}
.bmzq {
  font-size: 5vw;
  font-weight: 600;
}
.ggbj {
  width: 100vw;
  height: 20vw;
  margin-top: 8vw;
  position: relative;
}
.xdfw {
  background: url(../../img/home/xdfw.png) no-repeat center;
  width: 100vw;
  height: 100vw;
  /* overflow: hidden; */
  text-align: center;
}
.banner {
  height: 55vw;
  /* overflow: hidden; */
  margin-top: 8vw;
}
.singe-line {
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
  font-size: 4vw;
}
#banner >>> img {
  height: 55vw;
  width: 90vw;
  border-radius: 10px;
  /* object-fit: cover; */
}
/deep/ .van-swipe {
  height: 55vw;
}
/deep/ .van-swipe__track {
  height: 55vw;
}
/deep/.van-swipe__indicator {
  background: #919191;
}

/deep/ .van-swipe__indicator--active {
  background-color: #d9a557ff !important;
  width: 18px;
  border-radius: 2px;
}

/deep/ .van-swipe__indicators {
  left: 50vw;
  top: 50vw;
}

/deep/ .van-swipe__indicator {
  background: rgb(145, 145, 145);
}
.ul-scoll {
  overflow: hidden;
  height: 15vw;
  position: relative;
  top: -1vw;
}
</style>



// WEBPACK FOOTER //
// src/views/Home/index.vue